import { render, staticRenderFns } from "./Modal-receive-boxFront.vue?vue&type=template&id=66d833a5&scoped=true&"
import script from "./Modal-receive-boxFront.vue?vue&type=script&lang=js&"
export * from "./Modal-receive-boxFront.vue?vue&type=script&lang=js&"
import style0 from "./Modal-receive-boxFront.vue?vue&type=style&index=0&id=66d833a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d833a5",
  null
  
)

export default component.exports